import { TranscriptionFilter } from '../../model/transcription/types'
import Api from './Api'

class TranscriptionsApi extends Api {
    constructor(baseUrl: string, headers: any) {
        super(baseUrl, '/Transcriptions', headers)
    }

    get = (botId: string, page: Number, startDate: string, endDate: string, filters: any) =>
        this.instance.get(`/${botId}/?page=${page}&startDate=${startDate}&endDate=${endDate}`, {
            params: {
                ...filters
            }
        })

    getConversation = (botId: string, dialogId: string) =>
        this.instance.get(`/Conversation/${botId}/${dialogId}`)

    getById = (botId: string, dialogId: string) =>
        this.instance.get(`/${botId}/${dialogId}`)
}

export default TranscriptionsApi
